import { ImgID } from "../../image_loader/img_id.js";
import { ColorScheme } from "./color_scheme.js";
import { TextStyleScheme } from "./text_style_scheme.js";
import { UIImage } from "./ui_image.js";
import { MyTextAlign, MyTextVerticalAlign, UITextElement } from "./ui_text_element.js";

export class RewardCountBadge extends UIImage
{
  public static readonly DESIGN_SIZE = 72;

  private readonly count_text: UITextElement;
  private shown_count = 0;

  constructor( ctx: CanvasRenderingContext2D, x: number, y: number )
  {
    const size = LayoutScaler.widthFromDesign( RewardCountBadge.DESIGN_SIZE );
    super( ctx, x, y, size, LayoutScaler.heightFromDesign( RewardCountBadge.DESIGN_SIZE ), ImgID.UI_GameStartRedCircle );

    this.count_text = new UITextElement(
      ctx,
      0,
      0,
      size,
      size,
      {
        text: "",
        font_size: LayoutScaler.textSizeFromDesign( 36 ),
        font_weight: 900,
        text_color: ColorScheme.white,
        text_style: TextStyleScheme.geologica,
        text_align: MyTextAlign.Center,
        vertical_align: MyTextVerticalAlign.Center,
        shadow_blur: LayoutScaler.widthFromDesign( 5.4 ),
        shadow_color: ColorScheme.black_transparent,
        shadow_offset_y: LayoutScaler.yFromDesign( 2.7 ),
        scale_to_width: true,
        auto_wrap: false,
      }
    );
    this.addChild( this.count_text, true );

    this.setOpacityImmediate( 0 );
  }

  public name(): string { return "RewardCountBadge"; }

  public getCount(): number
  {
    return this.shown_count;
  }

  public setCount( count: number ): void
  {
    const safe_count = Math.max( 0, Math.floor( count ) );
    if ( safe_count === this.shown_count ) return;

    const was_visible = this.shown_count > 0;
    this.shown_count = safe_count;

    if ( safe_count > 0 )
      this.count_text.setText( String( safe_count ) );

    const visible = safe_count > 0;
    if ( visible !== was_visible )
    {
      this.setOpacityImmediate( visible ? 1 : 0 );
      this.forceMakeShouldBeRendered();
    }
  }
}
